import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create((colors) => ({
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: theme.spacing[5],
    paddingVertical: theme.spacing[4],
    backgroundColor: colors.backgroundPrimaryInverse,
  },
  titleContainer: {
    flex: 1,
  },

  container: {
    flex: 1,
    position: 'relative',
    backgroundColor: colors.backgroundPrimaryInverse,
  },
  webView: {
    flex: 1,
    backgroundColor: colors.backgroundPrimaryInverse,
  },
  loadingOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: colors.backgroundPrimaryInverse,
  },
}));
